module.exports = __webpack_public_path__ + "static/media/pdf-icon.0352bcd5.svg";